import React from 'react';
import styled from 'styled-components';

import {Device} from '../../../constants';

import SimpleCard from './SimpleCard';

interface StepsData {
  stepsHeader: string;
  steps: Step[];
}

interface Step {
  bgImg: string;
  stepNumber: string;
  title1: string;
  title2: string;
}

const StyledStepperSection = styled.section`
  h2 {
    text-align: center;
  }
`;

const StyledStepperContainer = styled.div`
  display: flex;
  gap: 32px;

  @media screen and ${Device.tablet} {
    flex-direction: column;
  }
`;

const Steps = ({stepsHeader, steps}: StepsData) => {
  return (
    <StyledStepperSection>
      <h2>{stepsHeader}</h2>
      <StyledStepperContainer>
        {steps.map((step, index) => (
          <SimpleCard
            key={`how-to-play-step-${index}`}
            img={step.bgImg}
            eyebrow={step.stepNumber}
            title={step.title1}
            desc={step.title2}
          />
        ))}
      </StyledStepperContainer>
    </StyledStepperSection>
  );
};

export default Steps;
